module.exports = __webpack_public_path__ + "static/blockchain-icon-67a0adbee1e35ec5837505caf578517c.png";